/* Hook de tempo real: escuta o WebSocket autenticado /api/ws/updates e chama
   onUpdate (debounced) a cada mutação de pedidos em qualquer estação. */
import { useEffect, useRef } from "react";
import { API, getUser } from "@/lib/api";

export function useRealtimeOrders(onUpdate) {
  const cbRef = useRef(onUpdate);
  cbRef.current = onUpdate;

  useEffect(() => {
    let ws = null;
    let retry = null;
    let debounce = null;
    let closed = false;
    let attempts = 0;

    const connect = () => {
      if (!getUser() || closed) return;
      try {
        // Cookie HttpOnly vai automaticamente no handshake (mesma origem)
        ws = new WebSocket(`${API.replace(/^http/, "ws")}/ws/updates`);
        ws.onopen = () => { attempts = 0; };
        ws.onmessage = () => {
          clearTimeout(debounce);
          debounce = setTimeout(() => cbRef.current?.(), 400);
        };
        ws.onclose = (e) => {
          // 4401 = token inválido/expirado — não adianta reconectar (usuário precisa relogar)
          if (closed || e?.code === 4401) return;
          attempts += 1;
          const delay = Math.min(30000, 2000 * 2 ** Math.min(attempts, 4));
          retry = setTimeout(connect, delay);
        };
      } catch (e) {
        console.warn("Realtime WS falhou, reconectando:", e?.message);
        retry = setTimeout(connect, 8000);
      }
    };
    connect();

    const onVisible = () => {
      if (document.visibilityState === "visible") cbRef.current?.();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      closed = true;
      clearTimeout(retry);
      clearTimeout(debounce);
      document.removeEventListener("visibilitychange", onVisible);
      if (ws) { ws.onclose = null; ws.close(); }
    };
  }, []);
}
